import { makeStyles } from 'tss-react/mui';

type StyleProps = {
  color?: string;
};

const useStyles = makeStyles<StyleProps>({ name: 'TextLogo' })(
  ({ brandColors }, props) => ({
    textLogo: {
      fill: props?.color || brandColors.primaryMain,
    },
  })
);

export default useStyles;
